module.exports = __webpack_public_path__ + "img/icon-plus.50cfaf33.svg";